import {useQuery} from '@tanstack/react-query';
import {useCallback} from 'react';
import api from 'utils/api';

export enum Permission {
    CAN_ADMIN_ACTIONS = 'CAN_ADMIN_ACTIONS',
    Projects = 'CAN_PROJECTS_VIEW',
    CAN_PROJECTS_EDIT = 'CAN_PROJECTS_EDIT',
    Wells = 'CAN_WELLS_VIEW',
    canEditWells = 'CAN_WELLS_EDIT',
    canEditPads = 'CAN_WELL_PADS_EDIT',
    canEditFields = 'CAN_WELL_FIELDS_EDIT',
    Prices = 'CAN_PRICES_VIEW',
    CommonInfo = 'CAN_COMMON_INFO_EDIT',
    CanViewIncidentAnalyse = 'CAN_INCIDENT_ANALYSE_VIEW',
    CanViewAutoDrilling = 'CAN_AUTO_DRILLING_EDIT',
    CAN_VIEW_MONITORING = 'CAN_MONITORING_VIEW',
    CAN_VIEW_DRILLING_RIG = 'CAN_DRILLING_RIG_EDIT',
    CAN_VIEW_WELL_HEADER = 'CAN_WELL_HEADER_VIEW',
    CAN_VIEW_ASB_LOGO = 'CAN_ASB_LOGO_VIEW',
    CAN_VIEW_DRILLING_CARPET = 'CAN_DRILLING_CARPET_EDIT',
    CAN_VIEW_KNBK_IN_EXTERNAL_WELL = 'CAN_KNBK_IN_EXTERNAL_WELL_VIEW',
    CAN_VIEW_DRILLING_EFFICIENCY = 'CAN_DRILLING_EFFICIENCY_VIEW',
    CAN_VIEW_LAS_TAB = 'CAN_LAS_TAB_VIEW',
    CAN_VIEW_TND_TAB = 'CAN_TND_TAB_VIEW',
    CAN_VIEW_MONITORING_CONNECTION = 'CAN_MONITORING_CONNECTION_VIEW',
    CAN_VIEW_ADMIN_PANEL = 'CAN_ADMIN_PANEL_VIEW',
    CAN_DRM_VIEW = 'CAN_DRM_VIEW',
    CAN_DIGITAL_RIG_VIEW = 'CAN_DIGITAL_RIG_VIEW',
    CAN_CANDLE_CONSTRUCTION_VIEW = 'CAN_CANDLE_CONSTRUCTION_VIEW',
    CAN_STAGE_VIEW = 'CAN_STAGE_VIEW',
    CAN_DOWNLOAD_SUPERVISING_VIOLATIONS_REPORT = 'CAN_DOWNLOAD_SUPERVISING_VIOLATIONS_REPORT',
    CAN_DELETE_MONITORING_CONNECTIONS = 'CAN_DELETE_MONITORING_CONNECTIONS',
    CAN_VIDEO_STREAMING_CREATE = 'CAN_VIDEO_STREAMING_CREATE',
    CAN_VIEW_MY_RESOURCES = 'CAN_VIEW_MY_RESOURCES',
    CAN_ADMIN_NCI_EDIT = 'CAN_ADMIN_NCI_EDIT',
    CAN_VIEW_DRILLING_DATES = 'CAN_VIEW_DRILLING_DATES',
    CAN_COMPLETED_WELL_EDIT = 'CAN_COMPLETED_WELL_EDIT',
    CAN_EDIT_VIA_TRAJECTORY_CALCULATOR = 'CAN_EDIT_VIA_TRAJECTORY_CALCULATOR',
    CAN_EDIT_GRP = 'CAN_EDIT_GRP',
    CAN_VIEW_RISK_MAP = 'CAN_VIEW_RISK_MAP',
    CAN_CHANGE_COMPANY_WELL_LINK = 'CAN_CHANGE_COMPANY_WELL_LINK',
    CAN_DOWNLOAD_USER_LOGIN_REPORT = 'CAN_DOWNLOAD_USER_LOGIN_REPORT',
    CAN_USE_GENA = 'CAN_USE_GENA',
    CAN_VIEW_DD_CONTROL = 'CAN_VIEW_DD_CONTROL',
    CAN_VIEW_SLIDE_SHEET = 'CAN_VIEW_SLIDE_SHEET',
    CAN_EDIT_GGD_PLAN_REPAIR_PARAMS = 'CAN_EDIT_GGD_PLAN_REPAIR_PARAMS',
    CAN_EDIT_NPV_ACT = 'CAN_EDIT_NPV_ACT',
    CAN_VIEW_NPV_ACT = 'CAN_VIEW_NPV_ACT',
    CAN_VIEW_FILE_MANAGER = 'CAN_VIEW_FILE_MANAGER',
    CAN_VIEW_MINIAPPS = 'CAN_VIEW_MINIAPPS',
}

export const usePermissions = () => {
    const getPermissions: () => Promise<Permission[]> = useCallback(() => {
        return api.get(`/me/permissions`);
    }, []);
    const {
        data: roles,
        isLoading,
        refetch,
    } = useQuery({
        queryKey: ['permissions'],
        queryFn: getPermissions,
        staleTime: 5 * (60 * 1000), // 5 mins
        gcTime: 8 * (60 * 1000), // 8 mins
    });

    return {roles, isLoading, refetch};
};
